// import { useState } from "react";
import {
  Menu,
  Button,
  Typography,
  Card,
  Image,
  theme,
  Space,
  Dropdown,
} from "antd";
import { merge } from "lodash";
import { BellFilled } from "@ant-design/icons";
import { NavLink, useLocation } from "react-router-dom";
import PlaylistAddIcon from "@material-ui/icons/PlaylistAdd";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import SettingsIcon from "@material-ui/icons/Settings";
import AssessmentIcon from "@material-ui/icons/Assessment";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import ExpenseIcon from "../../assets/icons/ExpenseIcon";
import { CaretDownOutlined } from "@ant-design/icons";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import DashboardIcon from "@material-ui/icons/Dashboard";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { HiChevronDoubleRight, HiChevronDoubleLeft } from "react-icons/hi";
import Title from "antd/es/typography/Title";
import Logo from "../../assets/images/favicon.png";
import useLocalStorage from "../../hooks/useLocalstorage";
import GhoshakLogo from "../../assets/images/ghoshakLogo.png";
import config from "../../config";
import { useRef } from "react";
import MarqueeText from "../commons/MarqueeText";
import GhoshakIcon from "../../assets/images/ghoshak-logo.png";
import { getOutlet } from "../../service";

const { Text } = Typography;
const { useToken } = theme;
let locationChanges = [];
function Sidenav({ collapse = false, onCollapse = () => {} }) {
  const [selectedKey, setSeletedKey] = useState(["1"]);
  const location = useLocation();
  const shopDetails = useSelector((state) => state.shopDetails);
  const [outletArray, setOutletArray] = useState([]);
  const dispatch = useDispatch();
  const [mainUserShopDetails, setMainUserShopDetails] = useLocalStorage(
    "mainUserShopDetails",
    []
  );
  const [state, setState] = useState(true);
  const outlets = useSelector((state) => state.outlets.outlets);
  const [selectValue, setSelectValue] = useState("main");
  const navigate = useNavigate();
  const marqueeRef = useRef(null);
  useEffect(() => {
    shopDetails.userType === "Shop" &&
      mainUserShopDetails.length === 0 &&
      fetchOutlets(shopDetails.shopId);
  }, [shopDetails.shopId, shopDetails.userType, mainUserShopDetails]);

  const fetchOutlets = async (shopId) => {
    try {
      var res = await getOutlet(shopId);

      if (res.code === "ERROR") {
        return alert(res.message);
      }
      dispatch({
        type: "SET_OUTLETS",
        payload: res.data,
      });
      setOutletArray(res.data);
    } catch (err) {
      console.log("Err", err);
    }
  };

  const handleOutletSelect = (v) => {
    locationChanges.push({
      ...shopDetails,
      userId: shopDetails.shopId,
      settings: shopDetails.settings,
      newBillSettings: shopDetails.newBillSettings,
      userPhoneNumber: shopDetails.phoneNumber,
    });
    setSelectValue(v);
    const outletData = outletArray.find((i) => i.userId === v);
    let updatedShopDetails = {};
    if (v === "main") {
      updatedShopDetails = {
        ...shopDetails,
        expensesType: mainUserShopDetails[0].expensesType,
        outletArea: undefined,
        outletState: undefined,
        ownerShopId: undefined,
        shopAddress: mainUserShopDetails[0].shopAddress,
        userId: mainUserShopDetails[0].userId
          ? mainUserShopDetails[0].userId
          : mainUserShopDetails[0].shopId,
        userId10Digit: mainUserShopDetails[0].userId10Digit,
        userPincode: mainUserShopDetails[0].userPincode,
        categoryList: mainUserShopDetails[0].categoryList,
        taxMaster: mainUserShopDetails[0].taxMaster,
        userType: "Shop",
        userPhoneNumber: mainUserShopDetails[0].userPhoneNumber,
      };
      setMainUserShopDetails([]);
      locationChanges = [];
      dispatch({
        type: "SET_SETTINGS",
        payload: mainUserShopDetails[0].settings,
      });
    } else {
      updatedShopDetails = {
        ...shopDetails,
        ownerShopId: outletData.ownerShopId,
        expensesType: outletData.expensesType,
        shopAddress: outletData.shopAddress,
        outletArea: outletData.outletArea,
        outletState: outletData.outletState,
        userId: outletData.userId,
        shopId: outletData.shopId,
        userId10Digit: outletData.userId10Digit,
        userPincode: outletData.userPincode,
        categoryList: outletData.categoryList,
        taxMaster: outletData.taxMaster,
        userPhoneNumber: shopDetails.phoneNumber,
        smsPackage: outletData.smsPackage
          ? outletData.smsPackage
          : shopDetails.smsPackage,
        smsCount: outletData.smsCount
          ? outletData.smsCount
          : shopDetails.smsCount,
        smsExpiryDate: outletData.smsExpiryDate
          ? outletData.smsExpiryDate
          : shopDetails.smsExpiryDate,
        userType: outletData.userType,
        settings: outletData.settings,
        newBillSettings: outletData.newBillSettings,
      };

      locationChanges.push(updatedShopDetails);
      setMainUserShopDetails(locationChanges);
      dispatch({
        type: "SET_SETTINGS",
        payload: outletData.settings,
      });
      if (outletData.newBillsettings) {
        dispatch({
          type: "INVOICE-NEWBILLSETTINGS",
          payload: merge({}, ...outletData.newBillsettings),
        });
      }
    }
    console.log("updatedShopDetails", updatedShopDetails);
    dispatch({
      type: "SET_SHOP_PROFILE",
      payload: updatedShopDetails,
    });
    navigate("/dashboard/overview");
  };

  const items = useMemo(() => {
    const path = [
      {
        label: "Dashboard",
        key: "1",
        icon: <DashboardIcon />,
        path: "/dashboard/overview",
        subPath: [
          "/dashboard",
          "/",
          "/dashboard/",
          "/dashboard/plan-and-pricing",
        ],
        show: true,
      },
      {
        label: "Shop Items",
        key: "2",
        icon: <PlaylistAddIcon />,
        path: "/dashboard/shop-items",
        show: true,
        subPath: ["/dashboard/bulk-price-update"],
      },
      {
        label: "Reports",
        key: "3",
        icon: <AssessmentIcon />,
        path: "/dashboard/stock-value-report",
        show: true,
      },
      {
        label: "Loyalty",
        key: "5",
        icon: <LoyaltyIcon />,
        path: "/dashboard/loyalty",
        show: true,
        subPath: ["/dashboard/loyalty-details"],
      },
      {
        label: "Customer",
        key: "6",
        icon: <SupervisorAccountIcon />,
        path: "/dashboard/customer-management",
        subPath: [
          "/dashboard/customer-management/bill-history",
          "/dashboard/customer-management/outstandings",
        ],
        show: true,
      },
      {
        label: "Vendor",
        key: "7",
        icon: <GroupAddIcon />,
        path: "/dashboard/vendor-management",
        show: true,
        subPath: [
          "/dashboard/vendor-management/vendor-details",
          "/dashboard/vendor-management/add-bill",
        ],
      },
      {
        label: "Expenses",
        key: "8",
        icon: <ExpenseIcon />,
        path: "/dashboard/expenses-management",
        show: true,
      },
      {
        label: "Counter",
        key: "11",
        icon: <CurrencyExchangeIcon />,
        path: "/dashboard/cash-management",
        show: true,
      },
      {
        label: "Employee",
        key: "12",
        icon: <SupervisorAccountIcon />,
        path: "/dashboard/employeeAccess",
        show: shopDetails.userType !== "Employee",
      },
      {
        label: "Settings",
        key: "13",
        icon: <SettingsIcon />,
        path: "/dashboard/settings",
        show: true,
      },
    ];
    if (shopDetails.shopType === "Restaurant") {
      const restaurantPages = [
        {
          label: "Orders",
          key: "9",
          icon: <AssessmentIcon />,

          path: "/dashboard/order-display",
          show: true,
        },
        {
          label: "Subscription",
          key: "10",
          icon: (
            <BellFilled style={{ marginTop: "-4px", fontSize: "1.5rem" }} />
          ),
          path: "/dashboard/subscription",
          subPath: [
            "/dashboard/subscription/create",
            "/dashboard/subscription/edit",
          ],
          show: true,
        },
      ];
      path.splice(9, 0, restaurantPages[0], restaurantPages[1]);
      return path;
    }
    return path;
  }, [shopDetails.shopType]);

  useEffect(() => {
    const key = items.find(
      (i) =>
        i.path === location.pathname || i.subPath?.includes(location.pathname)
    );
    if (key) {
      setSeletedKey(key.key);
    }
  }, [location.pathname, items]);

  const outletMenuItems = useMemo(() => {
    const mainShop = {
      key: "main",
      label: <div onClick={() => handleOutletSelect("main")}>Main</div>,
      style: {
        width: 150,
      },
    };
    const menuItems = outletArray.map((i) => {
      return {
        key: i.userId,
        label: (
          <div onClick={() => handleOutletSelect(i.userId)}>
            {i.outletArea ? i.outletArea : i.shopAddress}
          </div>
        ),
        style: {
          width: 200,
        },
      };
    });
    let result = [...menuItems];
    if (mainUserShopDetails.length > 0) {
      result.unshift(mainShop);
    }
    return result;
  }, [outletArray]);

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
      }}
    >
      <Card
        bodyStyle={{
          padding: 20,
        }}
        style={{
          marginBottom: 16,
        }}
      >
        {!collapse && (
          <Space direction="horizontal">
            <Image
              preview={false}
              src={GhoshakIcon}
              style={{
                width: 80,
                height: 30,
              }}
              alt="Ghoshak Logo"
            />
            <Typography.Text strong>Ghoshak Billing</Typography.Text>
          </Space>
        )}
        {collapse && (
          <Image
            style={{
              width: 40,
              height: 30,
            }}
            preview={false}
            src={Logo}
            alt="Ghoshak Logo"
          />
        )}
      </Card>
      <Card
        style={{
          marginBottom: 16,
        }}
        bodyStyle={{
          padding: "12px 20px 12px 20px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <div>
            <Image
              src={
                shopDetails.shopImageLocation !== "removed"
                  ? shopDetails.shopImageLocation
                  : "https://via.placeholder.com/300/ef4667/FFFFFF?text=GHOSHAK"
              }
              style={
                collapse
                  ? {
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: "0.5rem",
                    }
                  : {
                      width: 60,
                      height: 60,
                      objectFit: "cover",
                      borderRadius: "0.5rem",
                    }
              }
              preview={false}
            />
          </div>

          {console.log("outlets", outlets)}
          {!collapse && (
            <div>
              <Space size={"small"}>
                <>
                  <Title
                    level={5}
                    style={{
                      marginBottom: 0,
                      textTransform: "capitalize",
                      fontSize: 14,
                      display: "flex",
                      width: "120px",
                      overflow: "hidden",
                    }}
                    id="marqueeText"
                  >
                    <MarqueeText>
                      <span
                        style={{
                          fontWeight: 700,
                        }}
                      >
                        {shopDetails.shopName}
                      </span>
                      <Text type="secondary">
                        {shopDetails.outletArea && (
                          <span
                            style={{
                              borderLeft: "1px solid",
                              marginLeft: "4px",
                              paddingLeft: "4px",
                            }}
                          >
                            {shopDetails.outletArea}
                          </span>
                        )}
                      </Text>
                    </MarqueeText>
                  </Title>
                </>

                {outlets?.length > 0 && (
                  <Dropdown
                    getPopupContainer={(el) => el.parentNode}
                    menu={{
                      items: outletMenuItems,
                    }}
                    placement="bottom"
                    arrow
                  >
                    <Space direction="horizontal">
                      <CaretDownOutlined
                        style={{
                          fontSize: "1rem",
                          cursor: "pointer",
                          verticalAlign: "middle",
                        }}
                      />
                    </Space>
                  </Dropdown>
                )}
              </Space>
              <div>
                <Text type="secondary">
                  ShopId: {shopDetails.userId10Digit}
                </Text>
              </div>
            </div>
          )}
        </div>
      </Card>
      <div
        style={{
          background: "#fff",
          width: "100%",
          height: "calc(100% - 180px)",
          borderRadius: 4,
          paddingBottom: 10,
        }}
      >
        <Menu
          id="sidebar-wrapper"
          mode="inline"
          style={{
            background: "#fff",
            borderRadius: 8,
            padding: 8,
            overflowY: "auto",
            height: "100%",
            boxShadow: "0 23px 27px rgb(0 0 0 / 5%)",
          }}
          selectedKeys={selectedKey}
        >
          {items.map((i) => {
            return (
              <Menu.Item
                style={
                  collapse
                    ? {
                        borderRadius: "1rem",
                      }
                    : {}
                }
                key={i.key}
              >
                {i.show && (
                  <NavLink
                    to={i.path}
                    style={
                      collapse
                        ? {
                            paddingLeft: 0,
                            paddingRight: 0,
                            margin: "0 auto",
                            color: "inherit",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }
                        : {
                            color: "inherit",
                          }
                    }
                    className={
                      i.subPath?.includes(location.pathname)
                        ? "navlink active"
                        : "navlink"
                    }
                  >
                    <span
                      style={
                        collapse
                          ? {
                              margin: 0,
                            }
                          : {}
                      }
                      className="icon"
                    >
                      {i.icon}
                    </span>
                    {!collapse && (
                      <span
                        className="label"
                        style={{
                          fontWeight: 500,
                        }}
                      >
                        {" "}
                        {i.label}
                      </span>
                    )}
                  </NavLink>
                )}
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
      <Button
        style={{
          position: "absolute",
          bottom: -12,
          border: 0,
          width: "100%",
          height: 40,
        }}
        onClick={() => onCollapse(!collapse)}
      >
        {collapse ? (
          <HiChevronDoubleRight size={30} />
        ) : (
          <HiChevronDoubleLeft size={30} />
        )}
      </Button>
    </div>
  );
}

export default Sidenav;
